import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import DynamicComponent from 'components/elements/DynamicComponent'

import s from './FieldLabel.module.scss'
const cx = cn.bind(s)

interface IFieldLabelProps {
	className?: string
	label?: string | ReactNode
	variant?: 'default' | 'brainable' | 'editable' | 'new'
	required: boolean | undefined
	as?: 'label' | 'div'
}

const FieldLabel: FC<IFieldLabelProps> = ({
	className,
	variant = 'default',
	label,
	required,
	children,
	as = 'label',
}) => {
	return (
		<DynamicComponent tag={as} className={cx('label', className)}>
			{children}
			{label ? (
				<span className={cx('label__text', 'global-label-text', variant)}>
					{label} {required && <span className={cx('label__star')}>*</span>}
				</span>
			) : null}
		</DynamicComponent>
	)
}

FieldLabel.displayName = 'FieldLabel'

export default FieldLabel
